export const InvoiceCreated = 0
export const InvoiceSend = 1
export const InvoiceDeleted = 2
export const InvoiceCanceled = 3
export const CustomerApproved = 4
export const CustomerDeclined = 5

export const GetStatusText = status =>{
    switch (status){
        case InvoiceCreated:
            return "Счёт-фактура создан"
        case InvoiceSend:
            return "Счёт-фактура отправлено"
        case InvoiceDeleted:
            return "Счёт-фактура удалено"
        case InvoiceCanceled:
            return "Счёт-фактура отменен"
        case CustomerApproved:
            return "Утверждено заказчиком"
        case CustomerDeclined:
            return "Отклонено заказчиком"
        default:
            return "Счёт-фактура создан"
    }
}

export const GetStatusVariant = status => {
    switch (status) {
        case InvoiceCreated:
            return 'blue-grey darken-4 white--text'
        case InvoiceSend:
            return 'blue white--text'
        case InvoiceCanceled:
            return 'warning white--text'
        case InvoiceDeleted:
            return 'red white--text'
        case CustomerApproved:
            return 'green white--text'
        case CustomerDeclined:
            return 'red darken-4 white--text'
        default:
            return 'blue-grey darken-4 white--text'
    }
}